module.exports = __webpack_public_path__ + "static/media/w (31).a63dfe1c.jpg";